var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamPhotoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6364 16.8V21H32V23.8H27.6364V28H24.7273V23.8H20.3636V21H24.7273V16.8H27.6364ZM27.648 0C28.4451 0 29.0909 0.623 29.0909 1.3902V14.4788C28.1566 14.1611 27.1727 13.9992 26.1818 14V2.8H2.90909L2.91055 22.4L16.4262 9.3898C16.6763 9.14827 17.0095 9.00302 17.3631 8.98137C17.7167 8.95971 18.0663 9.06314 18.3462 9.2722L18.4829 9.3912L23.6393 14.3612C22.5115 14.692 21.465 15.2392 20.5628 15.9697C19.6607 16.7003 18.9216 17.5992 18.3902 18.6122C17.8587 19.6251 17.5459 20.7312 17.4706 21.8636C17.3953 22.9961 17.5591 24.1315 17.952 25.2014L1.44291 25.2C1.06009 25.1996 0.693086 25.053 0.42253 24.7923C0.151974 24.5317 -1.94117e-07 24.1783 0 23.8098V1.3902C0.00266188 1.02253 0.155491 0.670624 0.425473 0.410505C0.695455 0.150385 1.06092 0.00293251 1.44291 0H27.648ZM8.72727 5.6C9.49881 5.6 10.2388 5.895 10.7843 6.4201C11.3299 6.9452 11.6364 7.65739 11.6364 8.4C11.6364 9.14261 11.3299 9.8548 10.7843 10.3799C10.2388 10.905 9.49881 11.2 8.72727 11.2C7.95573 11.2 7.2158 10.905 6.67023 10.3799C6.12467 9.8548 5.81818 9.14261 5.81818 8.4C5.81818 7.65739 6.12467 6.9452 6.67023 6.4201C7.2158 5.895 7.95573 5.6 8.72727 5.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/team-photo-placeholder.9ab1d4c3ec70645ac152b786dea6afba.svg";
export { ForwardRef as ReactComponent };